<template>
  <span class="up-btn">
    <el-button
      @click="handleClick"
      size="mini">
      批量导入
    </el-button>
    <input ref="filElem" type="file" class="upload-file" @change="handleChange"
           accept="image/png, image/jpeg, image/jpg, video/mp4" multiple>
    <!--    <input id="multi" type="file" @change="handleChange" multiple-->
    <!--           accept="image/png, image/jpeg, image/jpg, video/mp4"/>-->
    <!--    <label for="multi" class="up-avatar-box">-->
    <!--      批量导入-->
    <!--    </label>-->
  </span>
</template>

<script>
export default {
  props: {
    datalist: []
  },
  methods: {
    handleClick (e) {
      this.$emit('click', e)
      this.$refs.filElem.dispatchEvent(new MouseEvent('click'))
    },
    handleChange (e) {
      this.$emit('choose', e)
    }
  }
}
</script>

<style>
/*.up-btn {*/
/*  position: relative;*/
/*  width: 80px;*/
/*  height: 28px;*/
/*  display: inline-block;*/
/*  vertical-align: middle;*/
/*  padding: 0;*/
/*  color: #606266;*/
/*  background: #fff;*/
/*  border: 1px solid #ced4da;*/
/*  border-radius: 3px;*/
/*  cursor: pointer;*/
/*  overflow: hidden;*/
/*  text-align: center;*/
/*  font-weight: 600;*/
/*}*/

/*.up-btn:hover {*/
/*  color: #348fe2;*/
/*  border-color: #c2ddf6;*/
/*  background-color: #ebf4fc;*/
/*}*/

.up-btn input {
  position: absolute;
  left: -9999px;
}

/*.up-btn .up-avatar-box {*/
/*  position: absolute;*/
/*  top: 0;*/
/*  left: 0;*/
/*  right: 0;*/
/*  bottom: 0;*/
/*  padding: 0px;*/
/*  cursor: pointer;*/
/*}*/

/*.up-btn i {*/
/*  width: 100%;*/
/*  height: 100%;*/
/*  line-height: 28px;*/
/*  font-size: 28px;*/
/*  color: #8c939d;*/
/*  text-align: center;*/
/*}*/

/*.up-btn .up-grid-item {*/
/*  cursor: pointer;*/
/*  width: 100%;*/
/*  height: 0;*/
/*  padding-bottom: 100%;*/
/*  overflow: hidden;*/
/*  position: relative;*/
/*  margin-bottom: 5px;*/
/*  border-radius: 2px;*/
/*  border: 1px solid #d9d9d9;*/
/*}*/

/*.up-btn .up-grid-item img {*/
/*  width: 100%;*/
/*  height: 100%;*/
/*  object-fit: cover;*/
/*  position: absolute;*/
/*  top: 0%;*/
/*  left: 0%;*/
/*}*/

/*.up-btn .up-grid-item .action {*/
/*  cursor: pointer;*/
/*  position: absolute;*/
/*  width: 100%;*/
/*  height: 100%;*/
/*  left: 0;*/
/*  top: 0;*/
/*  cursor: default;*/
/*  text-align: center;*/
/*  vertical-align: middle;*/
/*  line-height: 108px;*/
/*  color: #fff;*/
/*  opacity: 0;*/
/*  font-size: 12px;*/
/*  background-color: rgba(0, 0, 0, .5);*/
/*  transition: opacity .3s;*/
/*}*/

/*.up-btn .up-grid-item .action:hover {*/
/*  opacity: 1;*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/components/UploadButton.vue